import { createIdempotencyKey } from '../../utils/idempotency.js';
import { translateRuntimeKey } from '../../i18n/runtimeState.js';

const t = (key, fallback, params) =>
    translateRuntimeKey(`abx.case-ui.${key}`, fallback, params);

const EXCLUDABLE_STATUSES = new Set(['IN_PROGRESS', 'COMPLETE']);
const REOPENABLE_STATUSES = new Set(['COMPLETE', 'EXCLUDED']);

export function abxPrescriptionCreateAvailability(status) {
    if (status === 'IN_PROGRESS') return 'AVAILABLE';
    if (status === 'COMPLETE' || status === 'EXCLUDED') {
        return 'REOPEN_CASE';
    }
    return 'UNAVAILABLE';
}

export function abxCaseCompletionBlockers(abxCase = {}, prescriptions = []) {
    const active = prescriptions.filter((item) => item.status !== 'VOID');
    const blockers = [];
    if (abxCase.status !== 'IN_PROGRESS') {
        blockers.push(t('detail.mustProgress', 'The case must be Open.'));
    }
    if (!active.some((item) => item.status === 'FINAL')) {
        blockers.push(t('detail.finalizeOne', 'Finalize at least one course.'));
    }
    if (active.some((item) => !['FINAL', 'ABANDONED'].includes(item.status))) {
        blockers.push(
            t(
                'detail.finishDrafts',
                'Finalize or abandon every remaining draft course.'
            )
        );
    }
    return blockers;
}

export function abxCaseActions(
    abxCase = {},
    { canManage = false, prescriptions = [] } = {}
) {
    if (!canManage) return [];

    const sourceDeleted = Boolean(abxCase.source?.deleted);
    const actions = [];

    if (REOPENABLE_STATUSES.has(abxCase.status) && !sourceDeleted) {
        actions.push('reopen');
    }
    if (
        abxCase.status === 'IN_PROGRESS' &&
        !abxCaseCompletionBlockers(abxCase, prescriptions).length
    ) {
        actions.push('complete');
    }
    if (EXCLUDABLE_STATUSES.has(abxCase.status)) {
        actions.push('exclude');
    }

    return actions;
}

export function abxActionRemainsAvailable(action, availableActions = []) {
    return Boolean(action && availableActions.includes(action));
}

export function normalizeAbxReason(value) {
    return String(value ?? '').trim();
}

export function abxReasonError(value) {
    const reason = normalizeAbxReason(value);
    if (!reason)
        return translateRuntimeKey(
            'abx.prescription.validation.reason',
            'Enter a reason.'
        );
    if (reason.length > 1000)
        return translateRuntimeKey(
            'abx.prescription.validation.maxLength',
            'Use 1000 characters or fewer.',
            { maximum: 1000 }
        );
    return null;
}

export function createAbxIdempotencyKey(action) {
    return createIdempotencyKey(`abx-case-${action}`);
}
